<span [tooltip]="value | currency:'USD':'symbol':'1.2-2'" class="wrapped" container="body" delay="500">{{value | currency:'USD':'symbol':'1.0-0'}}</span>
